import { render } from "./TitlePisto.vue?vue&type=template&id=20119810&scoped=true"
import script from "./TitlePisto.vue?vue&type=script&lang=js"
export * from "./TitlePisto.vue?vue&type=script&lang=js"

import "./TitlePisto.vue?vue&type=style&index=0&id=20119810&scoped=true&lang=css"

import exportComponent from "E:\\Github\\Vue\\drinks\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20119810"]])

export default __exports__